module.exports = __webpack_public_path__ + "img/question-mark.ab19c8b1.svg";